import React from "react";

function RapcoHomeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <g clipPath="url(#clip0_302_22912)">
        <path
          fill="#5D21FF"
          d="M14.25 20.25v-6h-4.5v6h-6v-9.422a.74.74 0 01.244-.553l7.5-6.816a.74.74 0 011.003 0l7.51 6.816a.779.779 0 01.243.553v9.422h-6z"
          opacity="0.2"
        ></path>
        <path
          stroke="#5D21FF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.689"
          d="M20.25 20.25v-9.422a.778.778 0 00-.244-.553l-7.51-6.816a.74.74 0 00-1.002 0l-7.5 6.816a.741.741 0 00-.244.553v9.422M1.5 20.25h21"
        ></path>
        <path
          stroke="#5D21FF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.689"
          d="M14.25 20.25V15a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75v5.25"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_302_22912">
          <path fill="#fff" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default RapcoHomeIcon;
